import { Logger } from './logger';
import { fetchTccConfig } from './requests';
import { FeConfig, Path, RemoteBTMConfig, RemoteSessionReplayConfig } from './types';

export async function getBTMRemoteConfig(region: string, appName?: string, logger?: Logger) {
  let tccConfig: RemoteBTMConfig = {};
  if (!appName) {
    return tccConfig;
  }
  try {
    const res = await fetchTccConfig(appName, 'btm_page_pattern');
    const result = res.config.config_data.data[region.toUpperCase()] ?? res.config.config_data.data.SG;
    tccConfig = JSON.parse(result.data ? result.data : res.config.config_data.data.SG.data);
    return tccConfig;
  } catch (e) {
    logger?.error('fetch tcc config error', e);
  }
  return tccConfig;
}

export async function getSessionReplayRemoteConfig(region: string, appName?: string, logger?: Logger) {
  let tccConfig: RemoteSessionReplayConfig = {};
  if (!appName) {
    return tccConfig;
  }
  try {
    const res = await fetchTccConfig(appName, 'session_replay_config');
    let result = res?.config?.config_data?.data?.[region.toUpperCase()];
    if (!result) {
      if (region.toUpperCase() !== 'CB') {
        result = res?.config?.config_data?.data?.SG;
      } else {
        result = {
          data: JSON.stringify({
            enableSessionReplay: false,
            enableOncall: false,
            experiments: []
          })
        };
      }
    }
    tccConfig = JSON.parse(result?.data ? result?.data : res?.config?.config_data?.data?.SG?.data);
    return tccConfig;
  } catch (e) {
    logger?.error('fetch tcc config error', e);
  }
  return tccConfig;
}

export async function getTrajectory(region: string, appName?: string, logger?: Logger) {
  let tccConfig: Path[] = [];
  if (!appName) {
    return tccConfig;
  }
  try {
    const res = await fetchTccConfig(appName, 'journey_trajectory');
    let result = res.config.config_data.data[region.toUpperCase()];
    if (!result) {
      if (region.toUpperCase() !== 'CB') {
        result = res.config.config_data.data.SG;
      } else {
        result = {
          data: JSON.stringify([])
        };
      }
    }
    tccConfig = JSON.parse(result.data ? result.data : '[]');
    return tccConfig;
  } catch (e) {
    logger?.error('fetch trajectory config error', e);
  }
  return tccConfig;
}

export async function getFeConfig(region: string, appName?: string, logger?: Logger) {
  let tccConfig: FeConfig = {};
  if (!appName) {
    return tccConfig;
  }
  try {
    const res = await fetchTccConfig(appName, 'fe_trajectory_config');
    let result = res.config.config_data.data[region.toUpperCase()];
    if (!result) {
      if (region.toUpperCase() !== 'CB') {
        result = res.config.config_data.data.SG;
      } else {
        result = {
          data: JSON.stringify([])
        };
      }
    }
    tccConfig = JSON.parse(result.data ? result.data : '[]');
    return tccConfig;
  } catch (e) {
    logger?.error('fetch fe config error', e);
  }
  return tccConfig;
}
export const sleep = async (time?: number): Promise<void> => {
  await new Promise((resolve) => setTimeout(resolve, time));
};
